import React, { Component } from 'react';
import { getJwt, isTokenExpired, isValid, isInternalUser } from '../utils/auth';
import { withRouter } from 'react-router-dom';
import Loading from '../ui/Loading';
import { getUserCorporate, getMenu, getUnreadCount } from '../utils/rest';
import Protected from '../ui/Protected';
import * as consts from '../static/constants';
class Authentication extends Component {

    componentDidCatch(error, info) {
        // Display fallback UI
        this.props.history.push("/404");
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, info);
    }

    componentDidUpdate(prevProps) {
        if (isTokenExpired()) {
            this.props.logout();
            this.props.history.push("/?r=expired");
        }
    }

    componentDidMount() {

        let paramsString = this.props.location.search;
        if (paramsString.length > 0) {
            const params = new URLSearchParams(paramsString);
            const token = params.get('token');
            if(token){
                localStorage.setItem(consts.ACCESS_TOKEN, token);
                this.props.history.push("/home");
            }
        }

        const jwt = getJwt();
        if (jwt && jwt.length > 0 && !isTokenExpired() && isValid()) {
            getMenu().then(response => {
                if (response != null) {
                    this.props.addItem("menuItems", response);
                    this.props.addItem("isInternalUser", isInternalUser());
                    getUserCorporate().then(response => {
                        let userCorporate = [];
                        if (response != null && response instanceof Array) {
                            let corporate = response;
                            corporate.forEach(item => {
                                const crp = {
                                    "key": item.id,
                                    "value": item.id,
                                    "text": item.name,
                                    "label": item.name,
                                    "clients": item.clients.map((client) => {
                                        //client.name = client.id + " " + client.name;                                      
                                        return client;
                                    })
                                };
                                userCorporate.push(crp);
                            });
                        } else {
                            this.props.history.push("/?r=No Corporate found..")
                        }
                        let sessionCorporate = localStorage.getItem("selectedCorporate");
                        //sessionStorage.getItem("selectedCorporate");
                        this.props.addItem("currentCorporate", sessionCorporate !== null ? sessionCorporate : userCorporate[0].value);
                        this.props.addItem("corporate", userCorporate);
                        this.props.addItem("loading", false);

                    }).catch((error) => {
                        this.props.addItem("loading", false);
                    });

                    getUnreadCount().then((response) => {
                        if (response !== null && response instanceof Object) {
                            this.props.addItem("notification", response);
                        }
                    })
                } else {
                    this.props.addItem("loading", false);
                    this.props.history.push("/?r=expired")
                }
            }).catch((error) => {
                this.props.addItem("loading", false);
            });
        } else {
            this.props.logout();
            this.props.history.push("/?r=expired")
        }
    }

    render() {
        if (this.props.items.loading) {
            return (
                <Loading />
            )
        }
        return (
            <div>
                <Protected  {...this.props} />
            </div>
        );
    }
}

export default withRouter(Authentication);


// WEBPACK FOOTER //
// ./src/app/login/Authentication.js